const DrawerLoading = () => (
  <div className='drawer'>
    <div className='drawer__pager'>
      <div className='drawer__inner' />
    </div>
  </div>
);

export default DrawerLoading;
